import React from 'react';
import AutosizeInput from 'react-input-autosize';
import t from 'react-translate';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { editTagFieldStyles, tagContainerStyles } from './styles';

interface EditTagFieldProps {
  value: string;
  onClose: () => void;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

const EditTagField: React.FC<EditTagFieldProps> = ({
  value,
  onClose,
  onChange,
  disabled = false,
}) => (
  <div css={editTagFieldStyles}>
    <AutosizeInput
      maxLength={50}
      inputClassName='tag-input'
      style={tagContainerStyles}
      name='tag-field-name'
      autoFocus
      autoComplete='off'
      placeholder={t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.AI_ASSISTANT.SEARCH_RECIPIENT()}
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      disabled={disabled}
    />
    <ClickableContainer onClick={onClose} className='close-btn'>
      <NvIcon icon='close' size='smallest' />
    </ClickableContainer>
  </div>
);

export default EditTagField;
